module.exports = __webpack_public_path__ + "assets/img/rule.c39986f2.png";